import { useContext } from 'react'

import { AppManagerContext } from '../providers/AppManager'

export const useAppManagerContext = () => {
  const context = useContext(AppManagerContext)

  if (!context) {
    throw new Error(
      "Unable to use 'useAppManagerContext' outside of 'AppManagerProvider'"
    )
  }

  return context
}
